import { StyledComponentProps } from "@mui/styles";
import { FeedClassKey, MaxThumbnailHeight } from 'assets/jss/common-styles';
import { ReactLightBoxGallery } from 'components/LightBox/react-lightbox-gallery';
import MuiClickable from 'components/MuiExtras/MuiClickable';
import { FileGetDto } from 'models/ApiModels';
import * as React from 'react';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface RenderImageState {
    open: boolean;
}

interface RenderImageProps {
    image: FileGetDto;
    thumbnail: FileGetDto;
    alt?: string;
}

type Props = RenderImageProps & StyledComponentProps<FeedClassKey>;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class RenderImage extends React.Component<Props, RenderImageState> {

    constructor(props: Props) {
        super(props);
        this.state = { open: false };
    }

    ///
    public render() {
        const { alt, image, thumbnail } = this.props;

        const img = thumbnail ? thumbnail : image;

        const imgClassName = img.metadata.width > img.metadata.height
            ? this.props.classes.contentPictureLandscape
            : this.props.classes.contentPicturePortrait;

        return (
            <>
                <MuiClickable
                    pointer="zoomIn"
                    onClick={() => this.setState({ open: true })}
                >
                    <img
                        src={img.url}
                        alt={alt}
                        className={imgClassName}
                    />
                </MuiClickable>
                <ReactLightBoxGallery
                    index={0}
                    images={[image]}
                    thumbnails={thumbnail == null ? [image] : [thumbnail]}
                    isOpen={this.state.open}
                    onClose={() => this.setState({ open: false })}
                />
            </>
        );
    }
}

export default RenderImage;